import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupBankAccount } from "src/components/Shared/NewForms/NFLookupBankAccount";
import { NFPlainNumber } from "src/components/Shared/NewForms/NFPlainNumber";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";

export const BankOpeningBalancesDetailLines = () => {
  const tableName = "lines";
  const { setValue, getValues } = useFormContext();
  const { t } = useTranslation();

  useEffect(() => {}, []);

  return (
    <>
      <NFormTable fieldArray={tableName}>
        <NFPlainNumber fieldName={"lineNo"} title={t("#")} width={50} />
        <NFLookupBankAccount fieldName={"bankAccountId"} title={t("BankAccount")} />
        <NFLookupCurrency fieldName={"currencyId"} title={t("Currency")} />
        <NFIntInput fieldName={"amount"} title={t("Amount")} />
        <NFIntInput fieldName={"currencyAmount"} title={t("CurrencyAmount")} />
      </NFormTable>
    </>
  );
};
